import {FC} from 'react'

import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'

import {ConsentCheckbox} from './ConsentCheckbox'

type MarketingConsentProps = {isDisabled?: boolean}

export const MarketingConsent: FC<React.PropsWithChildren<MarketingConsentProps>> = ({
  isDisabled,
}) => {
  const {t} = useTranslation()
  const {marketingConsentText} = useTrademarkVerificationContent().contactDetails

  return (
    <ConsentCheckbox
      name="marketing"
      consentText={t(marketingConsentText)}
      isDisabled={isDisabled}
    />
  )
}
